import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #3B3C43;
    font-size: .8em;
    margin: 3em 0 2em;

    & > * {
        margin-right: 2em;

        &:last-of-type {
            margin-right: 0;
        }
    }

    .rate {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .rate-title {
            margin-right: 1em;
            font-size: 14px;
        }

        .rating-stars {
            unicode-bidi: bidi-override;
            direction: rtl;
            display: flex;
            transform: translateY(-4px);
            flex-direction: row-reverse;

            &.disable {
                pointer-events: none;
            }

            > * {
                position: relative;
                cursor: pointer;
                font-size: 28px;
                color: #c29f5f;
                padding: 3px;

                &.scored {
                    color: #c7a563;

                    &:before {
                        content: "\\2605";
                        position: absolute;
                    }
                }

                &.active {
                    color: #ba8119;

                    &:before {
                        content: "\\2605";
                        position: absolute;
                    }
                }

                &.hovered {
                    color: #e2be7a;

                    &::before {
                        content: "\\2605";
                        position: absolute;
                    }
                }
            }
        }
    }

    .rating {
        font-size: 14px;

        .rating-number {
            font-weight: bold;
        }
    }

    .rate-count {
        font-size: 14px;

        .rate-count-number {
            font-weight: bold;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        flex-wrap: wrap;
        align-items: flex-start;

        .rate {
            justify-content: flex-start;
            width: 100%;
        }
    }
`;
